import { render, staticRenderFns } from "./SupplierEditTabBasic.vue?vue&type=template&id=289d9092&"
import script from "./SupplierEditTabBasic.vue?vue&type=script&lang=js&"
export * from "./SupplierEditTabBasic.vue?vue&type=script&lang=js&"
import style0 from "./SupplierEditTabBasic.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports